import { render, staticRenderFns } from "./heyxlsCollapse.vue?vue&type=template&id=6f8a2434&scoped=true&"
import script from "./heyxlsCollapse.vue?vue&type=script&lang=js&"
export * from "./heyxlsCollapse.vue?vue&type=script&lang=js&"
import style0 from "./heyxlsCollapse.vue?vue&type=style&index=0&id=6f8a2434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a2434",
  null
  
)

export default component.exports